import React, { useEffect, useState, useRef } from 'react';
import clsx from 'clsx';
import axios from 'axios';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import { useDispatch, useSelector } from 'react-redux';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Radio from '@material-ui/core/Radio';
import { Card, CardContent } from '@material-ui/core';
import useStyles from './checklistStyle';
import './styles.css';
import PreEngagementDocument from './preEngagementDocument';
import AssignEngLetter from './assignEngagementLetter';
import CpsChecklistGenerator from './generateCpsChecklist/accordin';
import AuditChecklist from './auditChecklistAccord/accordin';
import TaxAuditProcessChecklist from './taxAuditProcessChecklist/';
import TrialBalance from './trialBalance';

import CaroChecklist from './caroChecklist';
// import AgricultureIncomeDifferent from './agricultureincome';
import { CommonConfig } from '../../../config/common-config';

function a11yProps(index) {
    return {
        id: `scrollable-auto-tab-${index}`,
        'aria-controls': `scrollable-auto-tabpanel-${index}`,
    };
}

export default function AuditHome(props) {
    const dispatch = useDispatch({});
    const tabRef = useRef();
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const [checklist, setChecklist] = useState('');
    const tennantname = useSelector((state) => state.loginsuccessreducer.tennantName);
    const tennantnameValue = tennantname && tennantname.tennantName;
    const serviceIdValue = useSelector((state) => state.serviceCheckListReducer.serviceIdSelected);
    const serviceIdSelected = useSelector((state) => state.serviceCheckListReducer.serviceIdSelected);
    const jwtToken = {
        headers: {
            Authorization: bearerToken,
        },
    };
    const { match, history } = props;
    const { params } = match;
    const { page } = params;

    const tabNameToIndex = {
        0: 'PreEngagementDocument',
        1: 'AssignEngLetter',
        2: 'CpsChecklistGenerator',
        3: 'CaroChecklist',
        4: 'AuditChecklist',
        5: 'TaxAuditProcessChecklist',
        6: 'TrialBalance',
    };

    const indexToTabName = {
        PreEngagementDocument: 0,
        AssignEngLetter: 1,
        CpsChecklistGenerator: 2,
        CaroChecklist: 3,
        AuditChecklist: 4,
        TaxAuditProcessChecklist: 5,
        TrialBalance: 6,
    };
    const [value, setValue] = React.useState(indexToTabName[page]);
    // const [tabDisable0, setTabDisable0] = React.useState(true);
    // const [tabDisable1, setTabDisable1] = React.useState(true);
    // const [tabDisable2, setTabDisable2] = React.useState(true);
    // const [tabDisable3, setTabDisable3] = React.useState(true);
    // const [tabDisable4, setTabDisable4] = React.useState(true);
    // const [tabDisable5, setTabDisable5] = React.useState(true);
    // const [tabDisable6, setTabDisable6] = React.useState(true);

    const [tabDisable0, setTabDisable0] = React.useState(false);
    const [tabDisable1, setTabDisable1] = React.useState(false);
    const [tabDisable2, setTabDisable2] = React.useState(false);
    const [tabDisable3, setTabDisable3] = React.useState(false);
    const [tabDisable4, setTabDisable4] = React.useState(false);
    const [tabDisable5, setTabDisable5] = React.useState(false);
    const [tabDisable6, setTabDisable6] = React.useState(false);

    const handleChange = (event, newValue) => {
        history.push(`/menu/${tabNameToIndex[newValue]}`);
        setValue(newValue);
    };

    useEffect(() => {
        // const bearerToken = `Bearer ${userToken}`;
        axios
            .get(`${CommonConfig.dev.baseUrl1}/api/itr/checklist-by-serviceId/${tennantnameValue}/${serviceIdValue}`, jwtToken)
            .then((response) => {
                setChecklist(response.data);
                // dispatch(getGenInfoRequest(response.data.checklistJson.checklistL1));
            })
            .catch((error) => { });

        // axios
        // .get(`${CommonConfig.dev.baseUrl7030}/api/audit/get-sub-services/Advith/${serviceIdValue}`, jwtToken)
        // .then((response) => {
        //  response.data.content.map(x=> {
        //         if(x.subServiceType.subserviceName === "Pre Engagement"){
        //             setTabDisable0(false);
        //         }
        //         else if (x.subServiceType.subserviceName === "Engagement"){
        //             setTabDisable1(false);
        //         }
        //         else if (x.subServiceType.subserviceName === "CPS Checklist"){
        //             setTabDisable2(false);
        //         }
        //         else if (x.subServiceType.subserviceName === "CARO Checklist"){
        //             setTabDisable3(false);
        //         }
        //         else if (x.subServiceType.subserviceName === "Audit Process Checklist"){
        //             setTabDisable4(false);
        //         }
        //         else if (x.subServiceType.subserviceName === "Tax Audit Process Checklist"){
        //             setTabDisable5(false);
        //         }
        //         else if (x.subServiceType.subserviceName === "Trial Balance"){
        //             setTabDisable6(false);
        //         }
        //      });
        // })
        // .catch((error) => { });
    }, [userToken]);

    return (
        <div className="main-container">
            <AppBar position="static" color="default" className="custom-tab">
                <Tabs
                    value={value}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="scrollable auto tabs example"
                >
                    <Tab disabled={tabDisable0} label="Pre-Engagement Document" {...a11yProps(0)} />
                    <Tab disabled={tabDisable1} label="Assign Engagement Letter" {...a11yProps(1)} />
                    <Tab disabled={tabDisable2} label="Generate CPS Checklist" {...a11yProps(2)} />
                    <Tab disabled={tabDisable3} label="Caro Checklist" {...a11yProps(3)} />
                    <Tab disabled={tabDisable4} label="Audit Checklist" {...a11yProps(4)} />
                    <Tab disabled={tabDisable5} label="Tax Audit Process Checklist" {...a11yProps(5)} />
                    <Tab disabled={tabDisable6} label="Trial Balance" {...a11yProps(6)} />
                </Tabs>
            </AppBar>
            {value === 0 && <PreEngagementDocument />}
            {value === 1 && <AssignEngLetter />}
            {value === 2 && <CpsChecklistGenerator />}
            {value === 3 && <CaroChecklist />}
            {value === 4 && <AuditChecklist />}
            {value === 5 && <TaxAuditProcessChecklist />}
            {value === 6 && <TrialBalance />}
        </div>
    );
}
